@if (loading()) {
  <app-table-skeleton [rows]="loadingRows()" [cols]="loadingCols()" />
} @else if (isEmpty()) {
  <div class="flex flex-col items-center justify-center py-20 gap-4 text-center px-6">
    @if (emptyIcon()) {
      <div class="w-12 h-12 rounded flex items-center justify-center" style="background:rgb(var(--talos-ink-rgb) / 0.05)">
        <lucide-icon [img]="emptyIcon()!" [size]="20" color="rgb(var(--talos-ink-rgb) / 0.3)" />
      </div>
    }
    <div>
      <p class="text-sm font-semibold text-talos-ink mb-1">{{ emptyTitle() }}</p>
      <p class="text-[11px]" style="color:rgb(var(--talos-ink-rgb) / 0.4)">{{ emptySubtitle() }}</p>
    </div>
  </div>
} @else {
  <div class="overflow-x-auto">
    <table class="w-full" [ngClass]="minWidthClass()">
      <thead class="bg-talos-bg" style="border-bottom:1px solid rgb(var(--talos-ink-rgb) / 0.06)">
        <tr>
          @for (label of columnLabels(); track $index) {
            <th class="text-left py-3 text-[9px] font-bold uppercase tracking-[0.2em]"
                [ngClass]="label ? 'px-6' : 'px-6 w-10'"
                style="color:rgb(var(--talos-ink-rgb) / 0.38)">
              @if (label) { {{ label | translate }} }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        <ng-content></ng-content>
      </tbody>
    </table>
  </div>

  @if (showPagination()) {
    <app-pagination
      [currentPage]="currentPage()"
      [totalCount]="totalCount()"
      [pageSize]="pageSize()"
      (pageChange)="pageChange.emit($event)"
    />
  }
}
